import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { FormHelperText, FormControl } from '@material-ui/core'
import { getFieldProps, areEqual } from '../Field/utils'
import FormLabel from '../FormLabel'

function FormControlRadio ({ customComponent: Input, ...props }) {
  const {
    id,
    label,
    helperText,
    helperTextId,
    fullWidth,
    required,
    error,
    margin,
    ...fieldProps
  } = getFieldProps(props)

  return (
    <FormControl component="fieldset" error={error} fullWidth={fullWidth} required={required} margin={margin}>
      {label && <FormLabel component="legend" htmlFor={id}>{label}</FormLabel>}
      <Input {...fieldProps} id={id} />
      {helperText && (
        <FormHelperText id={helperTextId}>
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  )
}

FormControlRadio.defaultProps = {
  margin: 'normal',
  required: false
}

FormControlRadio.propTypes = {
  customComponent: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object
  ]).isRequired,
  margin: PropTypes.string,
  required: PropTypes.bool
}

export default memo(FormControlRadio, areEqual)
